import axios from "axios";

import { IP } from "../utils/Host";


export function updateDeletePrzerwaGant(global_id_grupa,refreshGantAll,proces_nazwa_id) {


if(proces_nazwa_id == 6 ){
  //oprawa
  axios.get(IP + "updateDeletePrzerwaOprawa/"+global_id_grupa+"/" + sessionStorage.getItem("token"))
    .then((res) => {
   refreshGantAll()

    });

}else{
      //pozostałe procesy

  axios.get(IP + "updateDeletePrzerwa/"+global_id_grupa+"/" + sessionStorage.getItem("token"))
    .then((res) => {
   refreshGantAll()

    });

}





}


